/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';
import {
    JsonEventCateringData,
    JsonEventCateringDataFromJSON,
    JsonEventCateringDataFromJSONTyped,
    JsonEventCateringDataToJSON,
} from './JsonEventCateringData';
import {
    JsonEventData,
    JsonEventDataFromJSON,
    JsonEventDataFromJSONTyped,
    JsonEventDataToJSON,
} from './JsonEventData';
import {
    JsonFloorShape,
    JsonFloorShapeFromJSON,
    JsonFloorShapeFromJSONTyped,
    JsonFloorShapeToJSON,
} from './JsonFloorShape';

/**
 * 
 * @export
 * @interface JsonEvent
 */
export interface JsonEvent {
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    abbr?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonEvent
     */
    allowedActions?: Array<JsonEventAllowedActionsEnum>;
    /**
     * 
     * @type {JsonEventCateringData}
     * @memberof JsonEvent
     */
    cateringData?: JsonEventCateringData;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonEvent
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    cleanFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    cleanTo?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEvent
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    description?: string;
    /**
     * 
     * @type {JsonEventData}
     * @memberof JsonEvent
     */
    eventData?: JsonEventData;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    eventFrom?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEvent
     */
    eventId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    eventTo?: string;
    /**
     * 
     * @type {Array<JsonFloorShape>}
     * @memberof JsonEvent
     */
    floorShapes?: Array<JsonFloorShape>;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    prepareFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    prepareTo?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    siwiId?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    status?: JsonEventStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEvent
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEvent
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonEventAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonEventStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE',
    New = 'NEW'
}

export function JsonEventFromJSON(json: any): JsonEvent {
    return JsonEventFromJSONTyped(json, false);
}

export function JsonEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'abbr': !exists(json, 'abbr') ? undefined : json['abbr'],
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'cateringData': !exists(json, 'cateringData') ? undefined : JsonEventCateringDataFromJSON(json['cateringData']),
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'cleanFrom': !exists(json, 'cleanFrom') ? undefined : json['cleanFrom'],
        'cleanTo': !exists(json, 'cleanTo') ? undefined : json['cleanTo'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'eventData': !exists(json, 'eventData') ? undefined : JsonEventDataFromJSON(json['eventData']),
        'eventFrom': !exists(json, 'eventFrom') ? undefined : json['eventFrom'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'eventTo': !exists(json, 'eventTo') ? undefined : json['eventTo'],
        'floorShapes': !exists(json, 'floorShapes') ? undefined : ((json['floorShapes'] as Array<any>).map(JsonFloorShapeFromJSON)),
        'prepareFrom': !exists(json, 'prepareFrom') ? undefined : json['prepareFrom'],
        'prepareTo': !exists(json, 'prepareTo') ? undefined : json['prepareTo'],
        'siwiId': !exists(json, 'siwiId') ? undefined : json['siwiId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonEventToJSON(value?: JsonEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'abbr': value.abbr,
        'allowedActions': value.allowedActions,
        'cateringData': JsonEventCateringDataToJSON(value.cateringData),
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'cleanFrom': value.cleanFrom,
        'cleanTo': value.cleanTo,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'description': value.description,
        'eventData': JsonEventDataToJSON(value.eventData),
        'eventFrom': value.eventFrom,
        'eventId': value.eventId,
        'eventTo': value.eventTo,
        'floorShapes': value.floorShapes === undefined ? undefined : ((value.floorShapes as Array<any>).map(JsonFloorShapeToJSON)),
        'prepareFrom': value.prepareFrom,
        'prepareTo': value.prepareTo,
        'siwiId': value.siwiId,
        'status': value.status,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

